const formatter = new Intl.NumberFormat(
  "de-DE", {
    style: "currency",
    currency: "EUR"
  }
);

export default function (value) {
  return formatter.format(value);
}
